
import { Component, input } from '@angular/core';
import { DxLoadIndicatorModule } from 'devextreme-angular';

@Component({
    selector: 'app-loading-div',
    imports: [DxLoadIndicatorModule],
    templateUrl: './loading-div.component.html',
    styleUrl: './loading-div.component.scss'
})
export class LoadingDivComponent {
    loading_message = input<string>('Loading...');
}
